import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Card from '../../../../../molecules/Card'
import SydInput from '../../../../../commonDesign/SydInput'
import { ICON_NAMES } from '../../../../../../constants'
import { useConnectionActions, useGroupedConnections } from './hooks'
import DomainGroup from './DomainGroup'

function ConnectionsListSidepanel ({
  root,
  connections,
  onSetSelectedConnection,
  selectedConnection
}) {
  const [searchText, setSearchText] = useState('')
  const domainGroups = useGroupedConnections(connections, searchText)
  const isSearching = searchText.trim().length > 0
  const connectionActions = useConnectionActions(root)

  return (
    <Card variant='outline'>
      <div className='flex flex-col gap-sm'>
        <SydInput
          iconName={ICON_NAMES.search}
          size='sm'
          minWidth='0'
          placeholder='Search connections...'
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        {domainGroups.map(group => (
          <DomainGroup
            key={group.domain}
            domain={group.domain}
            domainName={group.domainName}
            groupConnections={group.connections}
            selectedConnection={selectedConnection}
            onSelect={onSetSelectedConnection}
            connectionActions={connectionActions}
            forceExpanded={isSearching}
            defaultExpanded={
              domainGroups.length <= 4 ||
            group.connections.some(c => c === selectedConnection)
            }
          />
        ))}
        {isSearching && domainGroups.length === 0 && (
          <div className='px-2 py-1 font-size-xs text-neutral-500'>
            No connections match &ldquo;{searchText}&rdquo;
          </div>
        )}
      </div>
    </Card>
  )
}

ConnectionsListSidepanel.propTypes = {
  root: PropTypes.any,
  connections: PropTypes.object,
  onSetSelectedConnection: PropTypes.func.isRequired,
  selectedConnection: PropTypes.shape({
    connectionId: PropTypes.number
  })
}

export default ConnectionsListSidepanel
